import React from 'react';
import { FadeIn } from './FadeIn';
export function Skills() {
  const skills = [{
    name: 'Program Management',
    color: '#00E5FF'
  }, {
    name: 'Portfolio Management',
    color: '#7C3AED'
  }, {
    name: 'Enterprise Risk Management',
    color: '#E11D74'
  }, {
    name: 'Risk & Control Frameworks',
    color: '#10B981'
  }, {
    name: 'Stakeholder Management',
    color: '#FF6B35'
  }, {
    name: 'Cross-Functional Collaboration',
    color: '#C8A96A'
  }, {
    name: 'Governance',
    color: '#00E5FF'
  }, {
    name: 'Risk Management',
    color: '#7C3AED'
  }, {
    name: 'Analytics',
    color: '#E11D74'
  }, {
    name: 'Forecasting',
    color: '#10B981'
  }, {
    name: 'Reporting',
    color: '#FF6B35'
  }, {
    name: 'Optimization',
    color: '#C8A96A'
  }, {
    name: 'Leadership',
    color: '#00E5FF'
  }, {
    name: 'Communication',
    color: '#7C3AED'
  }];
  return <section id="skills" className="relative py-24 md:py-32 bg-navy border-t border-white/5 overflow-hidden" data-id="element-206">
      <div className="absolute top-0 right-1/4 w-[500px] h-[500px] rounded-full opacity-15 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.5) 0%, transparent 70%)'
    }} data-id="element-207"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-208">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20" data-id="element-209">
          <div className="lg:col-span-5" data-id="element-210">
            <FadeIn data-id="element-211">
              <div className="text-xs uppercase tracking-widest font-medium mb-6" style={{
              background: 'linear-gradient(90deg, #10B981, #00E5FF)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }} data-id="element-212">
                Capabilities
              </div>
              <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif text-softwhite leading-tight" data-id="element-213">
                A breadth of{' '}
                <span style={{
                background: 'linear-gradient(135deg, #10B981, #00E5FF)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }} data-id="element-214">
                  executive
                </span>{' '}
                and operational expertise.
              </h3>
            </FadeIn>
          </div>

          <div className="lg:col-span-7" data-id="element-215">
            <FadeIn delay={0.2} data-id="element-216">
              <div className="flex flex-wrap gap-3" data-id="element-217">
                {skills.map((skill, i) => <span key={i} className="px-5 py-2.5 border rounded-full text-softwhite/80 text-sm font-light hover:bg-white/[0.05] transition-all duration-300 cursor-default" style={{
                borderColor: `${skill.color}40`
              }} onMouseEnter={e => {
                ;
                (e.currentTarget as HTMLElement).style.color = skill.color;
                (e.currentTarget as HTMLElement).style.borderColor = skill.color;
                (e.currentTarget as HTMLElement).style.boxShadow = `0 0 20px ${skill.color}40`;
              }} onMouseLeave={e => {
                ;
                (e.currentTarget as HTMLElement).style.color = '';
                (e.currentTarget as HTMLElement).style.borderColor = `${skill.color}40`;
                (e.currentTarget as HTMLElement).style.boxShadow = '';
              }} data-id="element-218">
                    {skill.name}
                  </span>)}
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}